import { Campaign, DashboardCustomize, SportsTennis, SupportAgent } from '@mui/icons-material';
import Map from '@mui/icons-material/Map';
import SipClientContextProvider from 'pages/RemoteInspector/context/SipClientContextProvider';
import { lazy } from 'react';
import { Permissions } from 'services/enums';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const CommunicationPage = lazy(() => import('pages/CommunicationPage'));
const DashboardPage = lazy(() => import('pages/DashboardPage'));
const LocationPage = lazy(() => import('pages/LocationPage'));
const SipPage = lazy(() => import('pages/RemoteInspector'));
const SportsPage = lazy(() => import('pages/SportsPages'));

export const coreRoutes: IRouteProps[] = [
	{
		type: 'collapse',
		name: 'routersNames.dashboard',
		key: 'dashboard',
		icon: <DashboardCustomize />,
		route: `${DEFAULT_ROUTE}/dashboardPageClient`,
		isDisabled: false,
		permissionId: [Permissions.DASHBOARD],
		component: <DashboardPage />,
		protected: true,
	},
	{
		type: 'collapse',
		name: 'routersNames.location',
		key: 'location',
		icon: <Map />,
		route: `${DEFAULT_ROUTE}/location`,
		permissionId: [Permissions.LOCATION],
		component: <LocationPage />,
		protected: true,
	},
	{
		type: 'collapse',
		name: 'routersNames.communicationPage',
		key: 'communication',
		icon: <Campaign />,
		route: `${DEFAULT_ROUTE}/communication`,
		component: <CommunicationPage />,
		permissionId: [Permissions.COMMUNICATION],
		protected: true,
	},
	{
		type: 'collapse',
		name: 'routersNames.remoteTax',
		key: 'remoteInspector',
		icon: <SupportAgent />,
		route: `${DEFAULT_ROUTE}/remoteInspector`,
		permissionId: [Permissions.SIP_CLIENT],
		component: (
			<SipClientContextProvider>
				<SipPage />
			</SipClientContextProvider>
		),
		protected: true,
	},
];

export const sportsRoutes: IRouteProps[] = [
	{
		type: 'collapse',
		name: 'routersNames.sports',
		key: 'sports',
		route: `${DEFAULT_ROUTE}/sports`,
		icon: <SportsTennis />,
		permissionId: Permissions.SPORT_UNITIES,
		protected: true,
		component: <SportsPage />,
	},
];
